import React, { useEffect, useState } from "react";

const PageLoadProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(true);

  useEffect(() => {
    let start = 0;
    const end = 100;
    const duration = 800;
    const step = 10;
    const increment = (end / duration) * step;

    const interval = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(interval);
        setTimeout(() => setShowProgress(false), 300);
      }
      setProgress(start);
    }, step);

    return () => clearInterval(interval);
  }, []);

  if (!showProgress) return null;

  return (
    <div className="page-load-progress-wrapper">
      <div
        className="page-load-progress-bar bg-primary"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

export default PageLoadProgressBar;
